import Immutable from 'immutable';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import ThemeCardResult from './ThemeCardResult';
const defaults = {
  total: 0,
  items: Immutable.List()
};
class ThemeSearchResponse extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);
    if ('items' in json) {
      jsonCopy.items = Immutable.List(json.items.map(item => new ThemeCardResult(item)));
    }
    super(cleanObject(jsonCopy));
  }
}
export default ThemeSearchResponse;